import React from 'react';
import {REMOVE_DROP_SHADOW} from "../../Material-TableCustomization/CSSChanges/RemoveDropShadow";
import {ICONS_OVERRIDE_SECONDARY_COLOR} from "../../Material-TableCustomization/IconsOverride/IconsOverrideSecondaryColor";
import {LOCALIZATION} from "../../Material-TableCustomization/Localization/LocalizationES";
import MaterialTable from "material-table";
import {STUDENT_SCHOLARSHIPS_COLUMN_DEFINITION_PROPS} from "../../Material-TableCustomization/ColumnsDefinition/StudentScholarshipsColumnDefinitions";

export default function StudentScholarshipsTable({scholarships}) {
    return (
        <>
            <MaterialTable
                    columns={STUDENT_SCHOLARSHIPS_COLUMN_DEFINITION_PROPS()}
                    data={scholarships}
                    title="Becas"
                    isLoading={scholarships}
                    options={{
                        pageSize: 10,
                        addRowPosition: 'first',
                    }}
                    components={{
                        ...REMOVE_DROP_SHADOW
                    }}
                    icons={ICONS_OVERRIDE_SECONDARY_COLOR}
                    localization={LOCALIZATION('beca', 'becas')}
                />
        </>
    );
};